import React from 'react';
import { Plus } from 'lucide-react';
import { Button } from '../ui/button';

export default function ParticipantTypesTab({ participantTypes, setParticipantTypes }) {
  const updateParticipantType = (index, field, value) => {
    const updated = [...participantTypes];
    updated[index] = { ...updated[index], [field]: value };
    setParticipantTypes(updated);
  };

  return (
    <div className="space-y-6">
      <p className="text-sm text-gray-600">
        Configure participant types and their registration fees.
      </p>
      
      <div className="space-y-3">
        {participantTypes.map((pt, index) => (
          <div 
            key={pt.type}
            className={`p-4 rounded-lg border ${pt.enabled ? 'bg-white' : 'bg-gray-50 opacity-60'}`}
          >
            <div className="flex items-center gap-4">
              <label className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={pt.enabled}
                  onChange={() => updateParticipantType(index, 'enabled', !pt.enabled)}
                  className="w-4 h-4 text-green-600 rounded"
                  data-testid={`participant-type-enabled-${pt.type}`}
                />
                <span className="text-sm font-medium text-gray-700">Enabled</span>
              </label>
              
              <div className="flex-1 grid grid-cols-1 md:grid-cols-4 gap-4">
                <div>
                  <label className="block text-xs text-gray-500 mb-1">Type ID</label>
                  <input
                    type="text"
                    value={pt.type}
                    disabled
                    className="w-full px-3 py-2 text-sm border rounded-lg bg-gray-100 text-gray-900"
                  />
                </div>
                <div>
                  <label className="block text-xs text-gray-500 mb-1">Label</label>
                  <input
                    type="text"
                    value={pt.label}
                    onChange={e => updateParticipantType(index, 'label', e.target.value)}
                    className="w-full px-3 py-2 text-sm border rounded-lg text-gray-900 focus:ring-2 focus:ring-green-500"
                    data-testid={`participant-type-label-${pt.type}`}
                  />
                </div>
                <div>
                  <label className="block text-xs text-gray-500 mb-1">Fee (KES)</label>
                  <input
                    type="number"
                    value={pt.fee}
                    onChange={e => updateParticipantType(index, 'fee', parseInt(e.target.value) || 0)}
                    className="w-full px-3 py-2 text-sm border rounded-lg text-gray-900 focus:ring-2 focus:ring-green-500"
                    min={0}
                    data-testid={`participant-type-fee-${pt.type}`}
                  />
                </div>
                <div>
                  <label className="block text-xs text-gray-500 mb-1">Description</label>
                  <input
                    type="text"
                    value={pt.description}
                    onChange={e => updateParticipantType(index, 'description', e.target.value)}
                    className="w-full px-3 py-2 text-sm border rounded-lg text-gray-900 focus:ring-2 focus:ring-green-500"
                    data-testid={`participant-type-desc-${pt.type}`}
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      
      {/* Add New Participant Type */}
      <div className="pt-4 border-t">
        <Button
          variant="outline"
          onClick={() => {
            const newType = `type_${Date.now()}`;
            setParticipantTypes([
              ...participantTypes,
              { type: newType, label: 'New Type', fee: 0, description: '', enabled: true }
            ]);
          }}
          className="gap-2"
          data-testid="add-participant-type-btn"
        >
          <Plus className="w-4 h-4" />
          Add Participant Type
        </Button>
      </div>
      
      {/* Preview */}
      <div className="bg-gray-50 rounded-xl p-4">
        <p className="text-sm font-medium text-gray-700 mb-3">Pricing Preview</p>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
          {participantTypes.filter(pt => pt.enabled).map(pt => (
            <div key={pt.type} className="bg-white rounded-lg p-3 text-center border">
              <p className="font-medium text-gray-900 text-sm">{pt.label}</p>
              <p className="text-lg font-bold text-green-600">
                {pt.fee === 0 ? 'FREE' : `KES ${pt.fee}`}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
